import { useState, useEffect } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { JournalApprovalRequest } from "models/journal-approval";
import { useAuth } from "src/contexts/AuthContext";

export const useJournalApprovalRequest = (requestId: string) => {
  const [request, setRequest] = useState<JournalApprovalRequest | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const fetchRequest = async (id: string, silent = false) => {
    if (!silent) setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(
        `${API_URL}/journal-approvals/${id}`,
        { method: "GET" }
      );
      const data = await checkResponse(response);
      setRequest(data);
    } catch (err) {
      console.error("Error fetching journal approval request:", err);
      setError("Failed to fetch the journal approval request.");
    } finally {
      if (!silent) setLoading(false);
    }
  };

  useEffect(() => {
    if (requestId) {
      fetchRequest(requestId);
    }
  }, [requestId]);

  return {
    request,
    loading,
    error,
    refetch: (silent?: boolean) => fetchRequest(requestId, silent),
  };
};
